import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import ReviewerGroupModel from '../../types/ReviewerGroupModel';
import {TscButtonType, AlertModal, TextInput} from '@techsmith/tsc-cloud-style-guide';
import Constants from '../../globals/Constants';
import FeedbackUserService from '../../services/FeedbackUserService/FeedbackUserService';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import Themeable from '../../types/Themeable';

export default class SaveGroupModal extends React.Component<SaveGroupModalProps, SaveGroupModalState> {
   readonly state: SaveGroupModalState = {groupName: '', errorsCanShow: false, isSubmitting: false, networkError: false};

   constructor(props: SaveGroupModalProps) {
      super(props);
      autoBind(this);
   }

   async onClickConfirm(): Promise<any> {
      const {reviewers, onClose} = this.props;

      if (this.getErrorText()) {
         return;
      }

      this.setState({isSubmitting: true});

      try {
         await FeedbackUserService.addReviewerGroup({GroupName: this.state.groupName.trim(), ReviewerEmailAddressesToAdd: reviewers.map(r => r.Email)});
         onClose();
      } catch (error) {
         this.setState({isSubmitting: false, networkError: true});
      }
   }

   onNameInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
      this.setState({groupName: event.currentTarget.value, networkError: false, errorsCanShow: true});
   }

   getErrorText(): string {
      const {networkError, groupName} = this.state;
      const {reviewerGroups} = this.props;
      const {invalidGroupName, groupNameExists, failedSaveGroup, invalidGroupNameLength} = Strings.errors;
      const trimmedGroupName = groupName.trim();

      if (!trimmedGroupName) {
         return invalidGroupName;
      }

      if (reviewerGroups.some(g => g.GroupName.toLowerCase() === trimmedGroupName.toLowerCase())) {
         return groupNameExists;
      }

      if (networkError) {
         return failedSaveGroup;
      }

      if (groupName.length > Constants.groupName.maxLength) {
         return invalidGroupNameLength.replace('{param0}', `${Constants.groupName.maxLength}`);
      }
   }

   render(): React.ReactElement<any> {
      const {onClose} = this.props;
      const {isSubmitting, groupName, errorsCanShow} = this.state;
      const {savingGroup, typeGroup, cancel, updateGroup, saveGroup} = Strings.labels;
      const alertTitle = isSubmitting ? savingGroup : saveGroup;
      const errorText = errorsCanShow ? this.getErrorText() : '';

      const alertModalContent = (
         <div className="save-group-alert">
            <TextInput value={groupName} errorText={errorText} placeholder={typeGroup} onChange={this.onNameInputChange} onEnter={this.onClickConfirm} disabled={isSubmitting} testId="save-group-input" />
         </div>
      );

      return (
         <AlertModal title={alertTitle}
                     onClose={onClose}
                     closeContent={cancel}
                     onConfirm={this.onClickConfirm}
                     confirmContent={updateGroup}
                     confirmButtonType={TscButtonType.primary}
                     onDismiss={onClose}
                     dismissContent={cancel}
                     disableConfirmButton={!!errorText || isSubmitting || !errorsCanShow}
                     testId="save-group-alert">
            {alertModalContent}
         </AlertModal>
      );
   }
}

export interface SaveGroupModalProps extends Themeable {
   reviewers: SimpleReviewerModel[];
   reviewerGroups: ReviewerGroupModel[];
   onClose(): void;
}

export interface SaveGroupModalState {
   groupName: string;
   isSubmitting: boolean;
   networkError: boolean;
   errorsCanShow: boolean;
}
